// import React, { useState } from "react";
// import "./Profile.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
// import Profile_Vendor from "../profile-vendor/Profile_Vendor";
// import Profile_Expert from "../profile-expert/Profile_Expert";

// const Profile = () => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [profileImage, setProfileImage] = useState(
//     "/assets/images/profile-icon.png",
//   );
//   const handleButtonClick = () => {
//     if (isEditing) {
//       console.log("Profile Saved!");
//     }
//     setIsEditing(!isEditing);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setProfileImage(imageUrl);
//       console.log("File selected:", file.name);
//     }
//   };
//   return (
//     <div className="profile-wrapper ">
//       <div className="profile-container container">
//         <div className="profile-card">
//           <div className="profile-image-wrapper">
//             <input
//               type="file"
//               id="profile-image-upload"
//               hidden
//               accept="image/*"
//               onChange={handleFileChange}
//             />

//             <img src={profileImage} alt="profile" className="profile-image" />
//             <label
//               htmlFor="profile-image-upload"
//               className="edit-icon"
//               style={{ cursor: "pointer" }}
//             >
//               <FontAwesomeIcon icon={faPencilAlt} />
//             </label>
//           </div>
//           <div className="profile-form">
//             <div className="form-row">
//               <div className="form-group">
//                 <input type="text" id="name" placeholder="Enter Full Name " />
//                 <label htmlFor="name">Full Name</label>
//               </div>

//               <div className="form-group">
//                 <input type="text" id="name" placeholder="Enter Full Name" />
//                 <label>Full Name</label>
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>Mobile No</label>
//                 <input type="text" placeholder="Enter Mobile No" />
//               </div>

//               <div className="form-group">
//                 <label>Whatsapp Number</label>
//                 <input type="text" placeholder="Enter Whatsapp No" />
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <input type="text" id="name" placeholder="Enter City" />
//                 <label>City</label>
//               </div>

//               <div className="form-group">
//                 <input type="text" id="name" placeholder="Enter State" />
//                 <label>State</label>
//               </div>
//             </div>

//             <button
//               className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
//               onClick={handleButtonClick}
//             >
//               {isEditing ? "Save Profile" : "Edit Profile"}
//             </button>
//           </div>
//         </div>
//       </div>
//       <Profile_Vendor />
//       <Profile_Expert />
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect } from "react"; // Added useEffect
import "./Profile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Profile_Vendor from "../profile-vendor/Profile_Vendor";
import Profile_Expert from "../profile-expert/Profile_Expert";
import Account_Created_Modal from "../../header/login/account-created-modal/Account_Created_Modal";
const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000); 

      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  const handleButtonClick = () => {
    if (isEditing) {
      console.log("Profile Saved!");
      setShowSuccess(true);
    }
    setIsEditing(!isEditing);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
      console.log("File selected:", file.name);
    }
  };

  return (
    <div className="profile-wrapper ">
      <div className="profile-container container">
        <div className="profile-card">
          <div className="profile-image-wrapper">
            <input
              type="file"
              id="profile-image-upload"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />

            <img src={profileImage} alt="profile" className="profile-image" />
            <label
              htmlFor="profile-image-upload"
              className="edit-icon"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </label>
          </div>
          <div className="profile-form">
            <div className="form-row">
              <div className="form-group">
                <input type="text" id="name" placeholder="Enter Full Name " />
                <label htmlFor="name">Full Name</label>
              </div>

              <div className="form-group">
                <input type="text" id="name" placeholder="Enter Full Name" />
                <label>Full Name</label>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Mobile No</label>
                <input type="text" placeholder="Enter Mobile No" />
              </div>

              <div className="form-group">
                <label>Whatsapp Number</label>
                <input type="text" placeholder="Enter Whatsapp No" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input type="text" id="name" placeholder="Enter City" />
                <label>City</label>
              </div>

              <div className="form-group">
                <input type="text" id="name" placeholder="Enter State" />
                <label>State</label>
              </div>
            </div>

            <button
              className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
              onClick={handleButtonClick}
            >
              {isEditing ? "Save Profile" : "Edit Profile"}
            </button>
          </div>
        </div>
      </div>
      <Profile_Vendor />
      <Profile_Expert />

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile;
